import React from "react"
import styled from "styled-components"
import { colors } from "buoy-theme"

import { Button } from "buoy-core"
import Check from "../../../completion/images/Check"
import Text from "../../../common/components/Text"

const NpsCommentFormTextArea = styled.textarea`
  border: transparent;
  border-radius: 4px;
  background-color: ${colors.neutralLightest};
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  padding: 16px;
  display: block;
  margin-bottom: 16px;
  line-height: 19px;
  letter-spacing: 0.2px;

  &:focus::placeholder {
    color: transparent;
  }

  &::placeholder {
    color: ${colors.neutral};
  }
  ${props => (props.submitted ? "opacity: 0.5" : "")}
`

const NpsCommentFormContent = styled.div`
  border-color: ${colors.neutralLight};
  max-width: 476px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const NpsCommentFormFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: no-wrap;
`

const NpsCommentForm = props => (
  <div>
    <form>
      <NpsCommentFormContent>
        <NpsCommentFormTextArea
          onChange={e => props.onChange(e)}
          placeholder="Comments or suggestions?"
          submitted={props.submitted}
          disabled={props.submitted}
        />
        <NpsCommentFormFooter>
          {props.submitted && (
            <React.Fragment>
              <Text color="primary" fontWeight="regular">
                Thank you for your feedback!
              </Text>
              <Check color="primary" margin="0px 8px" />
            </React.Fragment>
          )}
          <Button
            type="button"
            onClick={props.submitComment}
            disabled={props.submitted}
            buttonStyle="small"
            color="primary"
          >
            Submit
          </Button>
        </NpsCommentFormFooter>
      </NpsCommentFormContent>
    </form>
  </div>
)

export { NpsCommentForm as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/nps/NpsCommentForm.js